import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import UserSelect from '../Users/UserSelect'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { observer } from 'mobx-react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { ColorPicker } from 'material-ui-color';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import authStore from '../../Auth/AuthStore'
import mainStore from '../../../MainStore'
import ProjectStatistic from './ProjectStatistic'
import GroupSelectBlock from './GroupSelectBlock'
import ProjectEnvironments from './ProjectEnvironments'
import Participants from './Participants'
import './projects.css'
import ProjectStatusSelect from './ProjectStatusSelect';
import AccountSelect from '../Kanban/AccountSelect';
import Paper from '@mui/material/Paper';
import ProjectTypeSelect from './ProjectTypeSelect';
import ProjectStages from './ProjectStages';
import ProjectProducts from './ProjectProducts';
import ProjectServices from './ProjectServices';
import EnvironmentTable from '../Servers/EnvironmentTable';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import BranchTable from '../Branch/BranchTable';
import ProjectWageRates from './ProjectWageRates';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import FlagIcon from '@mui/icons-material/Flag';

const ProjectDialog = observer(class ProjectDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            fullscreen: true
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRowCheckedChange = this.handleRowCheckedChange.bind(this);
        this.handleRiskChange = this.handleRiskChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleGroupSelect = this.handleGroupSelect.bind(this);
        this.handleConsultantChange = this.handleConsultantChange.bind(this);
        this.handleManagerChange = this.handleManagerChange.bind(this);
    }

    /*componentWillUpdate(newProps) {
        if (newProps !== this.props) {
            this.setState({ isOpen: newProps.isOpen, project: newProps.project });
        }
    }*/

    handleGroupSelect(group) {
        var project = mainStore.openedProject;
        project.group = group;
        mainStore.setOpenedProject(project);
    }

    handleTabChange(event, newValue) {
        this.setState({ "selectedTab": newValue });
    }

    handleChange = name => evt => {
        var project = mainStore.openedProject;
        project[name] = evt.target.value;
        mainStore.openProjectDialog(project, mainStore.projectUpdateCallback);
        console.log(JSON.stringify(mainStore.openedProject));
    }

    handleRowCheckedChange = name => evt => {
        var project = mainStore.openedProject;
        project[name] = evt.target.checked;
        mainStore.openProjectDialog(project, mainStore.projectUpdateCallback)
    }

    handleRiskChange = name => evt => {
        var project = mainStore.openedProject;
        project[name] = evt.target.value;
        project.planHours = project.clientHours / (1 + project.riskPercent / 100);
        mainStore.openProjectDialog(project, mainStore.projectUpdateCallback);
    }

    handleAccountChange(account) {
        var project = mainStore.openedProject;
        project.accountId = !!account ? account.id : '';
        project.account = !!account ? account.name : '';
        project.accountColor = !!account ? account.color : '';
        mainStore.setOpenedProject(project);
    }

    handleSave() {
        var scope = this;
        mainStore.setMaskVisible();
        console.log(JSON.stringify(mainStore.openedProject));
        var token = localStorage.getItem("token");
        fetch('api/Project', {
            method: 'POST',
            body: JSON.stringify(mainStore.openedProject),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    if (mainStore.projectUpdateCallback) {
                        mainStore.projectUpdateCallback(result.project);
                    }

                    mainStore.setMaskUnvisible();
                    mainStore.closeProjectDialog();
                    if (scope.props.onCreated) {
                        scope.props.onCreated(result.project);
                    }
                }).catch((err) => console.log(err));
            }
        });
    }

    handleColorChange(color) {
        if (color) {
            var project = mainStore.openedProject;
            project.color = !!color.hex ? "#" + color.hex : color;
            mainStore.openProjectDialog(project, mainStore.projectUpdateCallback);
            mainStore.setOpenedProject(project);
        }
    }

    handleClose() {
        mainStore.closeProjectDialog();
    }

    formatDate(d) {
        var date = new Date(d);
        var month = (date.getMonth() + 1);
        if (month < 10) month = '0' + month;

        var day = date.getDate();
        if (day < 10) day = '0' + day;

        return date.getFullYear() + '-' + month + '-' + day;
    }

    handleStatusSelect(status) {
        var project = mainStore.openedProject;
        project.status = status.name;
        project.statusId = status.id;
        mainStore.setOpenedProject(project);
    }

    handleTypeSelect(type) {
        var project = mainStore.openedProject;
        project.type = type.name;
        project.typeId = type.id;
        mainStore.setOpenedProject(project);
    }

    handleOwnerChange(user) {
        var project = mainStore.openedProject;
        project.ownerId = !!user ? user.id : '';
        project.owner = !!user ? user.name : '';
        mainStore.setOpenedProject(project);
    }

    handleManagerChange(user) {
        var project = mainStore.openedProject;
        project.managerId = !!user ? user.id : '';
        project.manager = !!user ? user.name : '';
        mainStore.setOpenedProject(project);
    }

    handleConsultantChange(user) {
        var project = mainStore.openedProject;
        project.consultantId = !!user ? user.id : '';
        project.consultant = !!user ? user.name : '';
        mainStore.setOpenedProject(project);
    }

    render() {
        if (!this.props) {
            return <div></div>
        }

        return (
            <Dialog
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={mainStore.isProjectDialogOpen}
                maxWidth="md"
                fullScreen={this.state.fullscreen}
                fullWidth
            >
                <DialogTitle id="customized-dialog-title" style={{ "background": mainStore.openedProject.color}}>
                    {mainStore.openedProject && mainStore.openedProject.name}
                    {!this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': true }); }} size="large">
                        <FullscreenIcon />
                    </IconButton>
                    }
                    {this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': false }); }} size="large">
                        <FullscreenExitIcon />
                    </IconButton>

                    }
                </DialogTitle>
                <DialogContent dividers>
                    <AppBar position="static" color="default">
                        <Tabs
                            value={this.state.selectedTab}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Главная" />
                            <Tab label="SLA" />
                            <Tab label="Продукты" />
                            <Tab label="Статистика" />
                            <Tab label="Среды" />
                            <Tab label="Участники" />
                            <Tab label="Этапы" />
                            <Tab label="Ветки" />
                            <Tab label="Ставки" />
                        </Tabs>
                    </AppBar>
                    {this.state.selectedTab === 0 && <div className="card-inner-block">
                        <Typography component={'span'}>
                            <TextField required
                                id="standard-required"
                                label="Заголовок"
                                fullWidth
                                margin="normal"
                                value={mainStore.openedProject && mainStore.openedProject.name}
                                onChange={this.handleChange('name')}
                            />
                        </Typography>
                        <div className="clearfix">
                            <div className="half-project-block project-dialog-group">
                                <div className="project-dialog-group-caption">Часы</div>
                                <div className="clearfix">
                                    <div className="half-project-block">
                                        <TextField required
                                            id="standard-required"
                                            label="План. часы"
                                            fullWidth
                                            margin="normal"
                                            value={mainStore.openedProject && mainStore.openedProject.planHours}
                                            onChange={this.handleChange('planHours')}
                                        />
                                    </div>
                                    <div className="half-project-block ">
                                        <TextField required
                                            id="standard-required"
                                            label="Клиентские часы"
                                            fullWidth
                                            margin="normal"
                                            value={mainStore.openedProject && mainStore.openedProject.clientHours}
                                            onChange={this.handleRiskChange('clientHours')}
                                        />
                                    </div>
                                </div>
                                <div className="clearfix">
                                    <div className="half-project-block ">
                                        <TextField required
                                            id="standard-required"
                                            label="Риск, %"
                                            fullWidth
                                            margin="normal"
                                            value={mainStore.openedProject && mainStore.openedProject.riskPercent}
                                            onChange={this.handleRiskChange('riskPercent')}
                                        />
                                    </div>
                                    <div className="half-project-block">
                                        <TextField required
                                            id="standard-required"
                                            label="Премиальный фонд"
                                            fullWidth
                                            margin="normal"
                                            value={mainStore.openedProject && mainStore.openedProject.bonus}
                                            onChange={this.handleChange('bonus')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="half-project-block project-dialog-group">
                                <div className="project-dialog-group-caption">Даты</div>
                                <div className="half-project-block">
                                    <TextField
                                        id="date"
                                        label="Дата начала"
                                        type="date"
                                        value={this.formatDate(mainStore.openedProject.startDate)}
                                        onChange={this.handleChange('startDate')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="half-project-block">
                                    <TextField
                                        id="date"
                                        label="Дата завершения работ"
                                        type="date"
                                        value={this.formatDate(mainStore.openedProject.endDate)}
                                        onChange={this.handleChange('endDate')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="half-project-block">
                                    <TextField
                                        id="date"
                                        label="Дата акта"
                                        type="date"
                                        value={this.formatDate(mainStore.openedProject.actDate)}
                                        onChange={this.handleChange('actDate')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="clearfix">
                            <div className="half-project-block project-dialog-group">
                                <div className="project-dialog-group-caption">Связи</div>
                                <div className="clearfix">
                                    <div className="half-project-block">
                                        <UserSelect name={mainStore.openedProject.owner} label="Ответственный" handleSelect={this.handleOwnerChange} />
                                    </div>
                                    <div className="half-project-block">
                                        <UserSelect name={mainStore.openedProject.consultant} label="Главный КВ" handleSelect={this.handleConsultantChange} />
                                    </div>
                                </div>
                                <div className="clearfix">
                                    <div className="half-project-block">
                                        <UserSelect name={mainStore.openedProject.manager} label="МРК" handleSelect={this.handleManagerChange} />
                                    </div>
                                    <div className="half-project-block">
                                        <AccountSelect id={mainStore.openedProject.accountId} name={mainStore.openedProject.account} color={mainStore.openedProject.accountColor} label="Контрагент" handleSelect={this.handleAccountChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="half-project-block project-dialog-group">
                                <div className="project-dialog-group-caption">Информация</div>
                                <div className="clearfix">
                                    <div className="half-project-block">
                                        <GroupSelectBlock name={mainStore.openedProject.group ? mainStore.openedProject.group.name : ''} handleSelect={this.handleGroupSelect} />
                                    </div>
                                    <div className="half-project-block">
                                        <ProjectStatusSelect name={mainStore.openedProject.status} label="Состояние" handleSelect={this.handleStatusSelect} />
                                    </div>
                                </div>
                                <div className="clearfix">
                                    <div className="half-project-block">
                                        <div>
                                            <FormControl style={{ "min-width": "100px" }}>
                                                <InputLabel htmlFor="priority-select">Приоритет</InputLabel>
                                                <Select
                                                    value={mainStore.openedProject.priorityId}
                                                    onChange={this.handleChange('priorityId')}
                                                    input={<Input name="priority-select" id="priority-select" />}
                                                >
                                                    <MenuItem value="e025b304-80eb-4870-94e9-d0512984595b">Высочайший</MenuItem>
                                                    <MenuItem value="a2c913e8-8505-4d62-830c-f8c6b76e65e5">Высокий</MenuItem>
                                                    <MenuItem value="03d3011c-7afe-4c9e-aeee-9ec56323a1e1">Средний</MenuItem>
                                                    <MenuItem value="d70acf59-b060-40b3-9aa5-7d6e7adbeb94">Низкий</MenuItem>
                                                    <MenuItem value="dba44be7-64be-4e03-99d1-d20b1c9bd13c">Нижайший</MenuItem>
                                                    <MenuItem value="a9ae204e-085a-4898-ba85-28baa775b98d">Не делать</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="half-project-block">
                                        <ProjectTypeSelect label="Тип проекта" name={mainStore.openedProject.type} handleSelect={this.handleTypeSelect}/>
                                    </div>
                                </div>
                                <div className="clearfix">
                                    <div className="half-project-block">
                                        <div>
                                            <Typography>
                                                <TextField
                                                    id="prefix"
                                                    label="Префикс"
                                                    fullWidth
                                                    margin="normal"
                                                    value={mainStore.openedProject.prefix}
                                                    onChange={this.handleChange('prefix')}
                                                />
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        
                        <Typography>
                            <div className="half-project-block">
                                    Цвет на доске &nbsp;
                                <ColorPicker
                                    name='color'
                                    defaultValue={mainStore.openedProject.color}
                                    value={mainStore.openedProject.color}
                                    onChange={this.handleColorChange}
                                />
                                <div className="project-color-example-square" style={{ background: mainStore.openedProject.color }}></div>
                            </div>
                            <div className="half-project-block">
                                Продукт
                                <Checkbox checked={mainStore.openedProject.isProduct} onChange={this.handleRowCheckedChange('isProduct')} value="true" />
                            </div>
                        </Typography>
                        <Typography>
                            <TextField
                                id="description"
                                label="Описание"
                                fullWidth
                                multiline
                                margin="normal"
                                value={mainStore.openedProject.description}
                                onChange={this.handleChange('description')}
                            />
                        </Typography>
                    </div>}
                    {this.state.selectedTab === 1 && <div className="card-inner-block">
                        <ProjectServices project={mainStore.openedProject} />
                    </div>}
                    {this.state.selectedTab === 2 && <div className="card-inner-block">
                        <ProjectProducts project={mainStore.openedProject} />
                    </div>}
                    {this.state.selectedTab === 3 && <div className="card-inner-block">
                        <ProjectStatistic projectId={mainStore.openedProject && mainStore.openedProject.id}/>
                    </div>}
                    {this.state.selectedTab === 4 && <div className="card-inner-block">
                        <EnvironmentTable serverId="" accountId={mainStore.openedProject && mainStore.openedProject.accountId} groupColumn="typeName" />
                    </div>}
                    {this.state.selectedTab === 5 && <div className="card-inner-block">
                        <Participants projectId={mainStore.openedProject.id} />
                    </div>}
                    {this.state.selectedTab === 6 && <div className="card-inner-block">
                        <ProjectStages projectId={mainStore.openedProject.id} />
                    </div>}
                    {this.state.selectedTab === 7 && mainStore.openedProject.accountId && <div className="card-inner-block">
                        <BranchTable accountId={mainStore.openedProject.accountId} />
                    </div>}
                    {this.state.selectedTab === 8 && <div className="card-inner-block">
                        <ProjectWageRates projectId={mainStore.openedProject.id} />
                    </div>}


                    
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => window.open('/projectCalendar?projectId=' + mainStore.openedProject.id)}>Диаграмма</Button>
                    <Button onClick={this.handleSave} color="primary">
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
});

export default ProjectDialog;